// extracted by mini-css-extract-plugin
export default {"Header":"payouts_Header__pTWPD","info":"payouts_info__6anXM","grid":"payouts_grid__FTdCW","download":"payouts_download__XtvAx"};